<template>
  <component
    :is="to ? 'router-link' : 'div'"
    :to="to"
    :class="[
      'mx-1 px-3 mb-1 text-sm rounded-xl block ring-inset flex flex-grow items-center',
      getYPadding(),
      isHovered ? 'bg-zinc-300/40 dark:bg-black/10 ' : '',
      hover || to ? 'hover:bg-zinc-300/30 dark:hover:bg-black/10 cursor-pointer' : '',
    ]"
    @touchstart="isHovered = hover || Boolean(to)"
    @touchend="isHovered = false"
  >
    <div v-if="loading"><ion-skeleton-text animated :style="{width: getSkeletonWidth()}" /></div>
    <div v-else class="flex-grow min-w-0"><slot /></div>
    <div v-if="showChevron" class="ml-4">
      <ZeitIcon name="ChevronRight" class="w-5 h-5 opacity-25" />
    </div>
  </component>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';

  import {
    IonSkeletonText,
  } from '@ionic/vue';

  import ZeitIcon from '@/components/ui/ZeitIcon.vue';

  export default defineComponent({
    components: {
      IonSkeletonText,
      ZeitIcon,
    },
    props: {
      layout: {
        type: String,
        default: 'lg',
      },
      hover: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      to: {
        type: Object,
        default: undefined,
      },
      showChevron: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      getYPadding() {
        if (this.layout == 'xs') return 'py-1';
        if (this.layout == 'sm') return 'py-2';
        if (this.layout == 'md') return 'py-3';

        return 'py-4';
      },
      getSkeletonWidth() {
        return Math.floor(Math.random() * 40) + 60 + '%'
      }
    },
    data() {
      return {
        isHovered: false,
      }
    },
  })
</script>
